import CreatePartForm from './CreatePartForm'

export default CreatePartForm;